import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.sort";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Dependencies
import React from 'react';
import PropTypes from 'prop-types'; // Utils

import classNames from 'classnames'; // Components

import { Text } from '@nerdwallet/react-typography';
import Select from '@nerdwallet/react-select';
import Icon from '@nerdwallet/react-icon';
import InputGroup from '@nerdwallet/react-input-group';

var TableHeaders = function TableHeaders(_ref) {
  var viewConfig = _ref.viewConfig,
      sortKey = _ref.sortKey,
      hooks = _ref.hooks;

  function getSortKey() {
    return sortKey || viewConfig.defaultSortKey;
  }

  function handleSortBy(e) {
    var sortBy;
    var dataValue = e.currentTarget.getAttribute('data-value');

    if (dataValue) {
      sortBy = dataValue;
    } else {
      sortBy = e.currentTarget.value;
    } // only update sortBy if the value is changing


    if (getSortKey() !== sortBy) {
      // Dispatch the action
      hooks.sort({
        key: sortBy,
        order: e.currentTarget.getAttribute('data-order')
      });
    }
  }

  function renderSortBy() {
    var select = React.createElement(Select, {
      onChange: handleSortBy,
      value: getSortKey(),
      options: viewConfig.columns.reduce(function (result, column) {
        var sortable = column.sort && column.sort.sortable;

        if (sortable) {
          result.push({
            label: column.title,
            value: column.sort.key
          });
        }

        return result;
      }, [])
    });
    return React.createElement(InputGroup, {
      inputId: "sort-by-select",
      label: "Sort By:",
      input: select
    });
  }

  var sortbyDropdown;
  var ths = viewConfig.columns.map(function (column, idx) {
    var sort = column.sort;
    var sortable = sort && sort.sortable;
    var columnSortKey = sort && sort.key || '';
    var sortOrder = sort && sort.order || '';
    var onClick;
    var sortIcon;

    if (sortable) {
      onClick = {
        onClick: handleSortBy
      };
      sortIcon = React.createElement(Icon, {
        className: "sort-icon",
        font: "gizmo",
        icon: "navigatedown"
      });
    }

    return React.createElement("th", _extends({
      key: idx,
      className: classNames('column-title', {
        'sorting-by': getSortKey() === columnSortKey,
        sortable: sortable
      }),
      "data-value": columnSortKey,
      "data-order": sortOrder
    }, onClick), React.createElement(Text, {
      small: true
    }, column.title), sortIcon);
  }); // only show sort by dropdown on mobile if there's more than one option

  if (viewConfig.columns.some(function (column) {
    return column.sort && column.sort.sortable;
  })) {
    sortbyDropdown = React.createElement("tr", {
      className: "sortby-dropdown"
    }, React.createElement("th", {
      colSpan: ths.length
    }, renderSortBy()));
  }

  return React.createElement("thead", null, React.createElement("tr", {
    className: "sortby-headers"
  }, ths), sortbyDropdown);
};

TableHeaders.displayName = 'TableHeaders';
TableHeaders.propTypes = {
  viewConfig: PropTypes.object,
  sortKey: PropTypes.string,
  hooks: PropTypes.object
};
export default TableHeaders;